import { useMemo } from 'react';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useRankingsChartsDataContext } from './hooks/useRankingsChartsDataContext';

export const ByDepartment = () => {
    const { chartData } = useRankingsChartsDataContext();

    const { subtitles, values } = useMemo(() => {
        const items = (chartData?.byDepartment || [])
            .slice()
            .sort((a, b) => Number(b?.total || 0) - Number(a?.total || 0))
            .slice(0, 10);

        return {
            subtitles: items.map((item) => item?.nome_departamento || 'Não informado'),
            values: items.map((item) => Number(item?.total || 0))
        };
    }, [chartData]);

    return (
        <SimpleBars
            title="Ranking por Departamento"
            horizontal={true}
            subtitles={subtitles}
            values={values}
            height={420}
            showDataLabels={true}
        />
    );
};
